import * as React from "react";
import { singleton } from "logic/singleton";
const DndStylesContext = React.createContext(void 0);
export default singleton("contexts.DndStylesContext", () => DndStylesContext);
